<div class="container-fluid p-3">
  <div class="row mb-3">
    <div class="col-12">
      <button class="btn btn-primary me-4" (click)="goBack()">
        <i class="fa fa-arrow-left"></i> Volver a ofertas
      </button>

      <button type="button" class="btn btn-warning me-2" [routerLink]="['/companies/create-job-offer', viewEnums.Edit, jobOfferId]" *ngIf="jobOffer()?.isEnabled">
        <i class="fa-solid fa-pen-to-square"></i>
        Editar
    </button>
    </div>
  </div>

  <!-- Mensajes de carga y error -->
  <div *ngIf="isLoading()" class="row mb-3">
    <div class="col-12 text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="mt-2">Cargando información...</p>
    </div>
  </div>

  <div *ngIf="hasError()" class="row mb-3">
    <div class="col-12">
      <div class="alert alert-danger" role="alert">
        {{ errorMessage() }}
      </div>
    </div>
  </div>

  <!-- Detalles de la oferta laboral -->
  <div *ngIf="!isLoading() && !hasError() && jobOffer()" class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm rounded border-0">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 class="mb-0">{{ jobOffer()?.title }}</h4>
          <span class="badge rounded-pill" 
                [ngClass]="{'bg-success': jobOffer()?.statusName === 'Activo', 
                          'bg-danger': jobOffer()?.statusName === 'Inactivo',
                          'bg-warning text-dark': jobOffer()?.statusName === 'Pendiente',
                          'bg-info': !['Activo', 'Inactivo', 'Pendiente'].includes(jobOffer()?.statusName || '')}">{{ jobOffer()?.statusName || 'No especificado' }}</span>
        </div>
        <div class="card-body">
          <!-- Información básica siempre visible -->
          <div class="row mb-3">
            <div class="col-md-6 col-lg-3 mb-2">
              <span class="text-muted"><i class="fa fa-briefcase me-2"></i>{{ jobOffer()?.contractTypeName || 'Tipo no especificado' }}</span>
            </div>
            <div class="col-md-6 col-lg-3 mb-2">
              <span class="text-muted"><i class="fa fa-money-bill me-2"></i>{{ jobOffer()?.proposedSalary ? '$' + jobOffer()?.proposedSalary : 'Salario no especificado' }}</span>
            </div>
            <div class="col-md-6 col-lg-3 mb-2">
              <span class="text-muted"><i class="fa fa-calendar me-2"></i>Publicada: {{ formatDate(jobOffer()?.publicOn) }}</span>
            </div>
            <div class="col-md-6 col-lg-3 mb-2">
              <span class="text-muted"><i class="fa fa-calendar-times me-2"></i>Cierre: {{ formatDate(jobOffer()?.closeOn) }}</span>
            </div>
          </div>

          <!-- Acordeones con información detallada -->
          <div class="accordion" id="jobOfferAccordion">
            <!-- Acordeón 1: Descripción y responsabilidades -->
            <div class="accordion-item border-0 mb-3 shadow-sm">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDescription" aria-expanded="false" aria-controls="collapseDescription">
                  <i class="fa fa-file-text me-2"></i> Descripción y Responsabilidades
                </button>
              </h2>
              <div id="collapseDescription" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Descripción:</h6>
                      <p>{{ jobOffer()?.description || 'No hay descripción disponible' }}</p>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Responsabilidades:</h6>
                      <p>{{ jobOffer()?.responsabilities || 'No hay responsabilidades detalladas' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Acordeón 2: Requisitos y Habilidades -->
            <div class="accordion-item border-0 mb-3 shadow-sm">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseRequirements" aria-expanded="false" aria-controls="collapseRequirements">
                  <i class="fa fa-list-check me-2"></i> Requisitos y Habilidades
                </button>
              </h2>
              <div id="collapseRequirements" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <h6 class="text-primary mb-2">Requisitos generales:</h6>
                      <p>{{ jobOffer()?.requirenments || 'No hay requisitos especificados' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Lista de requisitos:</h6>
                      <ul class="list-group">
                        <li *ngFor="let req of jobOffer()?.requirementsList" class="list-group-item border-0 ps-0">
                          <i class="fa fa-check-circle text-success me-2"></i>{{ req.name }}
                        </li>
                        <li *ngIf="!jobOffer()?.requirementsList?.length" class="list-group-item border-0 ps-0 text-muted">
                          No hay requisitos específicos listados
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6 mb-3">
                      <h6 class="text-primary mb-2">Habilidades requeridas:</h6>
                      <ul class="list-group">
                        <li *ngFor="let skill of jobOffer()?.skills" class="list-group-item border-0 ps-0">
                          <i class="fa fa-check-circle text-success me-2"></i>{{ skill.name }}
                        </li>
                        <li *ngIf="!jobOffer()?.skills?.length" class="list-group-item border-0 ps-0 text-muted">
                          No hay habilidades específicas listadas
                        </li>
                      </ul>
                      
                      <h6 class="text-primary mb-2 mt-3">Certificaciones:</h6>
                      <ul class="list-group">
                        <li *ngFor="let cert of jobOffer()?.certifications" class="list-group-item border-0 ps-0">
                          <i class="fa fa-certificate text-warning me-2"></i>{{ cert.name }}
                        </li>
                        <li *ngIf="!jobOffer()?.certifications?.length" class="list-group-item border-0 ps-0 text-muted">
                          No hay certificaciones requeridas
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Nivel de Educación:</h6>
                      <p><i class="fa fa-graduation-cap me-2"></i>{{ jobOffer()?.educationLevelName || 'No especificado' }}</p>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Experiencia Laboral:</h6>
                      <p><i class="fa fa-briefcase me-2"></i>{{ jobOffer()?.workExperienceLevelName || 'No especificado' }}</p>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Idiomas requeridos:</h6>
                      <p>{{ jobOffer()?.languagesRequired || 'No especificado' }}</p>
                      <ul class="list-group">
                        <li *ngFor="let lang of jobOffer()?.requiredLanguages" class="list-group-item border-0 ps-0">
                          <i class="fa fa-language me-2"></i>{{ lang.name }}
                        </li>
                        <li *ngIf="!jobOffer()?.requiredLanguages?.length && !jobOffer()?.languagesRequired" class="list-group-item border-0 ps-0 text-muted">
                          No hay idiomas específicos requeridos
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Disponibilidad para viajar:</h6>
                      <p><i class="fa fa-plane me-2"></i>{{ jobOffer()?.travelDisponibilityName || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Autorización de empleo:</h6>
                      <p>
                        <i *ngIf="jobOffer()?.needEmploymentAuthorization" class="fa fa-check-circle text-success me-2"></i>
                        <i *ngIf="!jobOffer()?.needEmploymentAuthorization" class="fa fa-times-circle text-danger me-2"></i>
                        {{ jobOffer()?.needEmploymentAuthorization ? 'Se requiere autorización de empleo' : 'No se requiere autorización de empleo' }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Acordeón 3: Beneficios -->
            <div class="accordion-item border-0 mb-3 shadow-sm">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBenefits" aria-expanded="false" aria-controls="collapseBenefits">
                  <i class="fa fa-gift me-2"></i> Beneficios
                </button>
              </h2>
              <div id="collapseBenefits" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-12">
                      <h6 class="text-primary mb-2">Beneficios ofrecidos:</h6>
                      <p>{{ jobOffer()?.benefits || 'No hay descripción de beneficios disponible' }}</p>
                      
                      <div class="row mt-3">
                        <div class="col-md-12">
                          <div class="d-flex flex-wrap gap-2">
                            <span *ngFor="let benefit of jobOffer()?.benefitsList" class="badge bg-light text-dark p-2 shadow-sm">
                              <i class="fa fa-check text-success me-1"></i> {{ benefit.name }}
                            </span>
                            <span *ngIf="!jobOffer()?.benefitsList?.length" class="text-muted">
                              No hay beneficios específicos listados
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Acordeón 4: Información de contacto y aplicación -->
            <div class="accordion-item border-0 mb-3 shadow-sm">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseContact" aria-expanded="false" aria-controls="collapseContact">
                  <i class="fa fa-address-card me-2"></i> Información de contacto
                </button>
              </h2>
              <div id="collapseContact" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Persona de contacto:</h6>
                      <p><i class="fa fa-user me-2"></i>{{ jobOffer()?.contactInfoName || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Correo electrónico:</h6>
                      <p><i class="fa fa-envelope me-2"></i>{{ jobOffer()?.contactInfoEmail || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Teléfono:</h6>
                      <p><i class="fa fa-phone me-2"></i>{{ jobOffer()?.contactInfoPhone || 'No especificado' }}</p>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Método de aplicación:</h6>
                      <p><i class="fa fa-file-upload me-2"></i>{{ jobOffer()?.jobApplicationMethodName || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Nombre de la empresa:</h6>
                      <p><i class="fa fa-building me-2"></i>{{ jobOffer()?.ownerFullName || 'No especificado' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Acordeón 5: Ubicación y detalles adicionales -->
            <div class="accordion-item border-0 mb-3 shadow-sm">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLocation" aria-expanded="false" aria-controls="collapseLocation">
                  <i class="fa fa-map-marker me-2"></i> Ubicación y detalles adicionales
                </button>
              </h2>
              <div id="collapseLocation" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Ubicación:</h6>
                      <p><i class="fa fa-map-pin me-2"></i>{{ jobOffer()?.cityName || 'No especificada' }}{{ jobOffer()?.stateName ? ', ' + jobOffer()?.stateName : '' }}{{ jobOffer()?.countryName ? ', ' + jobOffer()?.countryName : '' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Dirección:</h6>
                      <p><i class="fa fa-home me-2"></i>{{ jobOffer()?.address || 'No especificada' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Posibilidad de trabajo remoto:</h6>
                      <p><i class="fa fa-laptop-house me-2"></i>{{ jobOffer()?.remoteWorkPossibilityName || 'No especificado' }}</p>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-primary mb-2">Departamento:</h6>
                      <p><i class="fa fa-sitemap me-2"></i>{{ jobOffer()?.departmentName || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Posición:</h6>
                      <p><i class="fa fa-id-badge me-2"></i>{{ jobOffer()?.positionName || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Vacantes disponibles:</h6>
                      <p><i class="fa fa-users me-2"></i>{{ jobOffer()?.availablePositions || jobOffer()?.vacantPositions || 'No especificado' }}</p>
                      
                      <h6 class="text-primary mb-2 mt-3">Horario de trabajo:</h6>
                      <p><i class="fa fa-clock me-2"></i>{{ jobOffer()?.workingTime || 'No especificado' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Lista de candidatos aplicados -->
  <div *ngIf="!isLoading() && !hasError() && jobOffer()" class="row">
    <div class="col-12">
      <div class="card shadow-sm rounded border-0">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 class="mb-0">Candidatos aplicados</h4>
          <div>
            <button class="btn btn-sm btn-success me-2" (click)="exportCandidatesToXlsx()" [disabled]="!candidates().length">
              <i class="fa fa-file-excel-o me-1"></i> Exportar Excel (XLSX)
            </button>
            <span class="badge bg-light text-dark">Total: {{ totalItems() }}</span>
          </div>
        </div>
        <div class="card-body">
          <!-- Mensaje cuando no hay candidatos -->
          <div *ngIf="candidates().length === 0" class="text-center py-5">
            <i class="fa fa-users fa-3x text-muted mb-3"></i>
            <h5>No hay candidatos aplicados a esta oferta</h5>
            <p class="text-muted">Los candidatos que apliquen a esta oferta aparecerán aquí.</p>
          </div>

          <!-- Lista de candidatos -->
          <div *ngIf="candidates().length > 0">
            <div class="table-responsive">
              <table class="table table-hover" style="min-height: 300px; overflow-y: auto;">
                <thead>
                  <tr>
                    <th scope="col">Foto</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Email</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Match</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody class="table-group-divider" >
                  <tr *ngFor="let candidate of candidates()">
                    <td>
                      <img [src]="candidate.photoUrl" alt="Foto de perfil" class="rounded-circle" width="100" height="100" style="object-fit: cover;">
                    </td>
                    <td>{{ candidate.firstName }} {{ candidate.lastName }}</td>
                    <td>{{ candidate.email }}</td>
                    <td>{{ candidate.primaryPhone || candidate.cellPhone || 'No disponible' }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="progress flex-grow-1" style="height: 10px;">
                          <div class="progress-bar" role="progressbar" 
                               [ngClass]="{
                                 'bg-danger': (candidate.matchPercent || 0) < 40,
                                 'bg-warning': (candidate.matchPercent || 0) >= 40 && (candidate.matchPercent || 0) < 70,
                                 'bg-success': (candidate.matchPercent || 0) >= 70
                               }"
                               [style.width.%]="candidate.matchPercent || 0">
                          </div>
                        </div>
                        <span class="ms-2 fw-bold">{{ candidate.matchPercent || 0 }}%</span>
                      </div>
                    </td>
                    <td>
                      <!-- Indicador de carga -->
                      <div *ngIf="(loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.loading" 
                           class="d-inline-block me-2">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                          <span class="visually-hidden">Cargando...</span>
                        </div>
                      </div>
                      
                      <!-- Indicador de error -->
                      <div *ngIf="(loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.error" 
                           class="d-inline-block me-2">
                        <i class="fa fa-exclamation-triangle text-danger" title="Error al actualizar el estado"></i>
                      </div>
                      
                      <!-- Skeleton loader cuando está cargando -->
                      <span *ngIf="(loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.loading" 
                            class="skeleton-loader">
                      </span>
                      
                      <!-- Badge de estado (se oculta durante la carga) -->
                      <span *ngIf="!((loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.loading)" 
                            class="badge rounded-pill" [ngClass]="{
                        'bg-warning text-dark': getApplicationStatusId(candidate) === 1,
                        'bg-info': getApplicationStatusId(candidate) === 2,
                        'bg-success': getApplicationStatusId(candidate) === 3,
                        'bg-danger': getApplicationStatusId(candidate) === 4,
                        'bg-primary': getApplicationStatusId(candidate) === 5,
                        'bg-secondary': getApplicationStatusId(candidate) === 99
                      }">
                        {{ getApplicationStatusName(candidate) }}
                      </span>
                    </td>
                    <td >
                      <div class="d-flex">
                      <button class="btn btn-sm btn-outline-primary me-1" 
                              (click)="viewCandidateResume(candidate.userId, candidate.resumeId)"
                              [disabled]="!candidate.resumeId">
                        <i class="fa fa-file-text-o"></i> Perfil
                      </button>

                      <div class="dropdown">
                        <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" 
                                [id]="'statusDropdown' + candidate.jobApplicationId" data-bs-toggle="dropdown" 
                                [disabled]="(loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.loading"
                                aria-expanded="false">
                          <i class="fa" [ngClass]="{
                            'fa-edit': !((loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.loading),
                            'fa-spinner fa-spin': (loadingCandidates() | keyvalue)?.length && (loadingCandidates().get(candidate.jobApplicationId || 0))?.loading
                          }"></i> Estado
                        </button>
                        <ul class="dropdown-menu" [attr.aria-labelledby]="'statusDropdown' + candidate.jobApplicationId">
                          <li><a class="dropdown-item" [class.disabled]="getApplicationStatusId(candidate) === 1" href="javascript:void(0)" (click)="updateCandidateStatusById(candidate, 1)">Pendiente</a></li>
                          <li><a class="dropdown-item" [class.disabled]="getApplicationStatusId(candidate) === 2" href="javascript:void(0)" (click)="updateCandidateStatusById(candidate, 2)">Entrevista</a></li>
                          <li><a class="dropdown-item" [class.disabled]="getApplicationStatusId(candidate) === 3" href="javascript:void(0)" (click)="updateCandidateStatusById(candidate, 3)">Aprobado</a></li>
                          <li><a class="dropdown-item" [class.disabled]="getApplicationStatusId(candidate) === 4" href="javascript:void(0)" (click)="updateCandidateStatusById(candidate, 4)">Rechazado</a></li>
                          <li><a class="dropdown-item" [class.disabled]="getApplicationStatusId(candidate) === 5" href="javascript:void(0)" (click)="updateCandidateStatusById(candidate, 5)">Contratado</a></li>
                          <li><hr class="dropdown-divider"></li>
                          <li><a class="dropdown-item" [class.disabled]="getApplicationStatusId(candidate) === 99" href="javascript:void(0)" (click)="updateCandidateStatusById(candidate, 99)">Otro</a></li>
                        </ul>
                      </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div class="d-flex justify-content-center mt-3">
              <app-pagination 
                [page]="page()" 
                [pageSize]="pageSize()" 
                [totalItems]="totalItems()" 
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)"
              ></app-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal para visualizar el perfil -->
<div class="modal fade" id="resumeModal" tabindex="-1" aria-labelledby="resumeModalLabel" aria-hidden="true" [ngClass]="{'show': showResumeModal()}" [ngStyle]="{'display': showResumeModal() ? 'block' : 'none'}">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="resumeModalLabel">Perfil</h5>
          <button type="button" class="btn-close btn-close-white" (click)="closeResumeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <!-- Estado de carga -->
        <div *ngIf="isLoadingResume()" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-2">Cargando perfil profesional...</p>
        </div>
        
        <!-- Error de carga -->
        <div *ngIf="hasResumeError()" class="alert alert-danger m-3" role="alert">
          <h5 class="alert-heading">Error al cargar el perfil</h5>
          <p>No se pudo cargar la información del perfil profesional.</p>
          <hr>
          <p class="mb-0">Intente nuevamente más tarde o contacte al soporte.</p>
        </div>
        
        <!-- Profile content with view tracking -->
        <!-- Uses candidate's publicResumeId for unified tracking -->
        <div *ngIf="!isLoadingResume() && !hasResumeError() && resumeData()"
             appViewTracker 
             [viewType]="ViewType.IndependentProfile" 
             [entityId]="selectedPublicResumeId() || selectedResumeId() || 0">
          <div class="d-flex justify-content-end mt-3 mb-3">
          <button type="button" class="btn btn-sm btn-primary me-2" (click)="printResume()">
            <i class="fa fa-print"></i> Imprimir Currículum
          </button>
          </div>
          <!-- Información personal -->
          <div class="p-4 bg-light">
            <div class="row">
              <div class="col-lg-3 col-md-4 text-center mb-3">
                <img [src]="getPhotoUrl(resumeData()?.personalInfo!.photoFileId)" class="img-fluid rounded-circle" 
                     alt="Foto de perfil" style="max-width: 150px; max-height: 150px; object-fit: cover;">
              </div>
              <div class="col-lg-9 col-md-8">
                <h2 class="mb-1">{{ resumeData()?.personalInfo?.firstName }} {{ resumeData()?.personalInfo?.lastName }}</h2>
                <h5 class="text-muted mb-3">{{ resumeData()?.personalInfo?.professionalProfile || 'Profesional' }}</h5>
                
                <div class="row">
                  <div class="col-md-6">
                    <p *ngIf="resumeData()?.personalInfo?.email">
                      <i class="fa fa-envelope me-2 text-primary"></i> {{ resumeData()?.personalInfo?.email }}
                    </p>
                    <p *ngIf="resumeData()?.personalInfo?.cellPhone || resumeData()?.personalInfo?.primaryPhone">
                      <i class="fa fa-phone me-2 text-primary"></i> 
                      {{ resumeData()?.personalInfo?.cellPhone || resumeData()?.personalInfo?.primaryPhone }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p *ngIf="resumeData()?.personalInfo?.city || resumeData()?.personalInfo?.stateName">
                      <i class="fa fa-map-marker me-2 text-primary"></i> 
                      {{ resumeData()?.personalInfo?.city }}{{ resumeData()?.personalInfo?.stateName ? ', ' + resumeData()?.personalInfo?.stateName : '' }}
                    </p>
                    <p *ngIf="resumeData()?.employments && resumeData()?.employments!.length > 0">
                      <i class="fa fa-briefcase me-2 text-primary"></i> 
                      Experiencia: {{ calculateExperienceYears(resumeData()!.employments) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Contenido principal del CV -->
          <div class="p-4">
            <div class="row">
              <!-- Columna izquierda -->
              <div class="col-lg-7 col-md-6 mb-4">
                <!-- Experiencia laboral -->
                <div class="mb-4">
                  <h5 class="border-bottom pb-2 text-primary">
                    <i class="fa fa-briefcase me-2"></i> Experiencia laboral
                  </h5>
                  
                  <div *ngIf="!resumeData()?.employments || resumeData()?.employments!.length === 0" class="text-muted">
                    No hay experiencia laboral registrada.
                  </div>
                  
                  <div *ngFor="let employment of resumeData()?.employments" class="card mb-3 border-0 shadow-sm">
                    <div class="card-body">
                      <h5 class="card-title">{{ employment.position }}</h5>
                      <h6 class="card-subtitle mb-2 text-muted">{{ employment.company }}</h6>
                      <p class="card-text mb-1">
                        <small>
                          <i class="fa fa-calendar me-1"></i>
                          {{ formatDate(employment.startDate) }} - 
                          {{ employment.currentJob ? 'Actual' : formatDate(employment.endDate) }}
                        </small>
                      </p>
                      <p class="card-text mb-0" *ngIf="employment.responsibility">
                        <strong>Responsabilidades:</strong><br>
                        {{ employment.responsibility }}
                      </p>
                      <p class="card-text" *ngIf="employment.achievement">
                        <strong>Logros:</strong><br>
                        {{ employment.achievement }}
                      </p>
                    </div>
                  </div>
                </div>
                
                <!-- Certificaciones -->
                <div class="mb-4">
                  <h5 class="border-bottom pb-2 text-primary">
                    <i class="fa fa-certificate me-2"></i> Certificaciones
                  </h5>
                  
                  <div *ngIf="!resumeData()?.certifications || resumeData()?.certifications!.length === 0" class="text-muted">
                    No hay certificaciones registradas.
                  </div>
                  
                  <div class="row">
                    <div *ngFor="let certification of resumeData()?.certifications" class="col-lg-6 mb-3">
                      <div class="card h-100 border-0 shadow-sm">
                        <div class="card-body">
                          <h6 class="card-title">{{ certification.name }}</h6>
                          <p class="card-subtitle text-muted">{{ certification.institution }}</p>
                          <p class="card-text mb-0">
                            <small>
                              <i class="fa fa-calendar me-1"></i> {{ formatDate(certification.completionDate) }}
                              <span *ngIf="certification.expirationDate"> - {{ formatDate(certification.expirationDate) }}</span>
                            </small>
                          </p>
                          <p class="card-text" *ngIf="certification.description">
                            {{ certification.description }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Columna derecha -->
              <div class="col-lg-5 col-md-6">
                <!-- Educación -->
                <div class="mb-4">
                  <h5 class="border-bottom pb-2 text-primary">
                    <i class="fa fa-graduation-cap me-2"></i> Educación
                  </h5>
                  
                  <div *ngIf="!resumeData()?.educations || resumeData()?.educations!.length === 0" class="text-muted">
                    No hay información educativa registrada.
                  </div>
                  
                  <div *ngFor="let education of resumeData()?.educations" class="card mb-3 border-0 shadow-sm">
                    <div class="card-body">
                      <h6 class="card-title">{{ education.career }}</h6>
                      <p class="card-subtitle mb-1 text-muted">{{ education.educationLevel }}</p>
                      <p class="card-text mb-1">{{ education.institution }}</p>
                      <p class="card-text mb-0">
                        <small>
                          <i class="fa fa-calendar me-1"></i>
                          {{ formatDate(education.startDate) }}
                          <span *ngIf="education.endDate"> - {{ formatDate(education.endDate) }}</span>
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
                
                <!-- Habilidades -->
                <div class="mb-4">
                  <h5 class="border-bottom pb-2 text-primary">
                    <i class="fa fa-cogs me-2"></i> Habilidades técnicas
                  </h5>
                  
                  <div *ngIf="!resumeData()?.skills || resumeData()?.skills?.length === 0" class="text-muted">
                    No hay habilidades técnicas registradas.
                  </div>
                  
                  <div class="d-flex flex-wrap gap-2 mb-3">
                    <span *ngFor="let skill of resumeData()?.skills" class="badge bg-light text-dark p-2">
                      {{ skill.skillName }} - {{ skill.skillLevel }}
                    </span>
                  </div>
                  
                  <h5 class="border-bottom pb-2 text-primary" *ngIf="resumeData()?.softSkills && resumeData()?.softSkills!.length > 0">
                    <i class="fa fa-user me-2"></i> Habilidades blandas
                  </h5>
                  
                  <div class="d-flex flex-wrap gap-2">
                    <span *ngFor="let skill of resumeData()?.softSkills" class="badge bg-light text-dark p-2">
                      {{ skill.skillName }} - {{ skill.skillLevel }}
                    </span>
                  </div>
                </div>
                
                <!-- Idiomas -->
                <div class="mb-4" *ngIf="resumeData()?.languages && resumeData()?.languages!.length > 0">
                  <h5 class="border-bottom pb-2 text-primary">
                    <i class="fa fa-language me-2"></i> Idiomas
                  </h5>
                  
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let language of resumeData()?.languages" class="list-group-item d-flex justify-content-between align-items-center border-0 ps-0">
                      {{ language.languageName }}
                      <span class="badge bg-primary rounded-pill">{{ language.languageLevel }}</span>
                    </li>
                  </ul>
                </div>
                
                <!-- Referencias -->
                <div class="mb-4" *ngIf="resumeData()?.references && resumeData()?.references!.length > 0">
                  <h5 class="border-bottom pb-2 text-primary">
                    <i class="fa fa-address-book me-2"></i> Referencias
                  </h5>
                  
                  <div *ngFor="let reference of resumeData()?.references" class="card mb-3 border-0 shadow-sm">
                    <div class="card-body">
                      <h6 class="card-title">{{ reference.firstName }} {{ reference.lastName }}</h6>
                      <p class="card-subtitle mb-1 text-muted">{{ reference.position }} en {{ reference.company }}</p>
                      <p class="card-text mb-0" *ngIf="reference.phone">
                        <i class="fa fa-phone me-1"></i> {{ reference.phone }}
                      </p>
                      <p class="card-text" *ngIf="reference.email">
                        <i class="fa fa-envelope me-1"></i> {{ reference.email }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeResumeModal()">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal para ingresar comentario cuando estado es "Otro" -->
<div class="modal fade" id="commentModal" tabindex="-1" aria-labelledby="commentModalLabel" aria-hidden="true" [ngClass]="{'show': showCommentModal()}" [ngStyle]="{'display': showCommentModal() ? 'block' : 'none'}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="commentModalLabel">Agregar comentario</h5>
        <button type="button" class="btn-close btn-close-white" (click)="cancelStatusUpdate()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>El estatus seleccionado es <strong>{{pendingStatus()}}</strong>. Por favor, añada un comentario adicional para el candidato:</p>
        <div class="mb-3">
          <textarea class="form-control" [ngModel]="statusComment()" (ngModelChange)="statusComment.set($event)" rows="4" placeholder="Escriba aquí su comentario..."></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancelStatusUpdate()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyStatusUpdate()">Guardar cambios</button>
      </div>
    </div>
  </div>
</div>

<!-- Overlay para los modales -->
<div *ngIf="showResumeModal() || showCommentModal()" class="modal-backdrop fade show" (click)="closeActiveModal()"></div>

<!-- Modal para mostrar el PDF del currículum -->
<div class="modal fade" id="modalDocumento" tabindex="-1" aria-labelledby="modalDocumentoLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalDocumentoLabel">
                    Currículum Vitae
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="ratio ratio-4x3">
                    <iframe id="docPrintDocumento"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>
